import React, { Component } from 'react';
import { Box, Chip, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon, faCircleHalfStroke, faBug, faSmileBeam, faBriefcase } from '@fortawesome/free-solid-svg-icons';

import Router from './components/pages/Router';
import Navbar from './components/helpers/Navbar';

export default class Main extends Component {
  constructor(props) {
    super(props);

    this.state = JSON.parse(window.localStorage.getItem('state')) || {
      themeNumber: 1
    };
  }

  setState(state) {
    window.localStorage.setItem('state', JSON.stringify(state));
    super.setState(state);
  }

  getTheme(themeNumber) {
    const themes = ['theme-sun', 'theme-moon', 'theme-light', 'theme-dark', 'theme-debug'];
    return themes[themeNumber];
  }

  getThemeIcon(themeNumber) {
    const themes = [faSun, faMoon, faCircleHalfStroke, faCircleHalfStroke, faBug];
    return themes[themeNumber];
  }

  getThemeStyleIcon(themeNumber) {
    const themeStyles = [faSmileBeam, faSmileBeam, faBriefcase, faBriefcase, faBug];
    return themeStyles[themeNumber];
  }

  changeTheme() {
    const {
      themeNumber
    } = this.state;
    
    let newThemes = [1, 0, 3, 2, 4];
    let newThemeNumber = newThemes[themeNumber];
    this.setState({ themeNumber: newThemeNumber });
  }

  changeThemeStyle() {
    const {
      themeNumber
    } = this.state;

    let newThemes = [2, 3, 0, 1, 4];
    let newThemeNumber = newThemes[themeNumber];
    this.setState({ themeNumber: newThemeNumber });
  }

  render() {
    const {
      themeNumber
    } = this.state;
    const theme = this.getTheme(themeNumber);
    const themeIcon = this.getThemeIcon(themeNumber);
    const themeStyleIcon = this.getThemeStyleIcon(themeNumber);

    return (
      <React.StrictMode>
        <Box className={theme}>
          <Box className='theme'>
            <Router />
            <Navbar />
            <Stack className='theme-icon'>
              <Chip className='theme-swapper theme-style' label={<FontAwesomeIcon icon={themeStyleIcon} />}
                component='a' onClick={() => this.changeThemeStyle()} clickable />
              <Chip className='theme-swapper' label={<FontAwesomeIcon icon={themeIcon} />}
                component='a' onClick={() => this.changeTheme()} clickable />
            </Stack>
          </Box>
        </Box>
      </React.StrictMode>
    );
  }
}
